import { mapGetters } from 'vuex';
import appNotificationMixin from '@/mixins/appNotification';


export default {
  mixins: [
    appNotificationMixin,
  ],
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    classModifiers() {
      return {
        'notification-item-simple': true,
        'notification-item-simple--long': this.text.length > 120,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/notification-items/notification-item-simple/notification-item-simple.js